<script lang="ts">
  // One titled section of the entry editor (Tijd, Werk, Financieel, Betaling).
  import type { Component, Snippet } from 'svelte';

  let { title, icon: Icon, children }: { title: string; icon?: Component<any>; children: Snippet } = $props();
</script>

<section class="section">
  <h3 class="eyebrow title">{#if Icon}<Icon size={15} />{/if}{title}</h3>
  {@render children()}
</section>

<style>
  .section { display: flex; flex-direction: column; gap: var(--space-4); }
  .section:not(:first-child) { padding-top: var(--space-5); border-top: 1px solid var(--border); }
  .title { display: flex; align-items: center; gap: var(--space-1_5); }
</style>
